export enum ErrorTypes {
  InvalidCredentials = "invalid_credentials",
  Email = "email",
}
